import dayjs from 'dayjs';
export { Dayjs } from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'dayjs/plugin/advancedFormat';
import 'dayjs/plugin/arraySupport';
import 'dayjs/plugin/badMutable';
import 'dayjs/plugin/buddhistEra';
import 'dayjs/plugin/calendar';
import 'dayjs/plugin/customParseFormat';
import 'dayjs/plugin/dayOfYear';
import 'dayjs/plugin/devHelper';
import 'dayjs/plugin/duration';
import 'dayjs/plugin/isBetween';
import 'dayjs/plugin/isLeapYear';
import 'dayjs/plugin/isMoment';
import 'dayjs/plugin/isSameOrAfter';
import 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';
import 'dayjs/plugin/isoWeek';
import 'dayjs/plugin/isoWeeksInYear';
import 'dayjs/plugin/localeData';
import 'dayjs/plugin/localizedFormat';
import 'dayjs/plugin/minMax';
import 'dayjs/plugin/objectSupport';
import 'dayjs/plugin/pluralGetSet';
import 'dayjs/plugin/preParsePostFormat';
import 'dayjs/plugin/quarterOfYear';
import 'dayjs/plugin/relativeTime';
import 'dayjs/plugin/timezone';
import 'dayjs/plugin/toArray';
import 'dayjs/plugin/toObject';
import 'dayjs/plugin/updateLocale';
import 'dayjs/plugin/utc';
import 'dayjs/plugin/weekOfYear';
import 'dayjs/plugin/weekYear';
import 'dayjs/plugin/weekday';
import Decimal from 'decimal.js';
import cryptoJs from 'crypto-js';
import Cookies from 'js-cookie';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * @description: 格式化时长，传入时长(秒)，格式化为x天x小时x分钟x秒
 * @param { number } duration 时长（秒）
 * @param { boolean } needSeconds 是否展示处理后的秒数，默认展示
 * @return { string } x天x小时x分钟x秒
 */

var formatSeconds = function formatSeconds(duration, needSeconds) {
  if (needSeconds === void 0) {
    needSeconds = true;
  }

  var days = Math.floor(duration / (3600 * 24));
  var hours = Math.floor((duration - days * 3600 * 24) / 3600);
  var minutes = Math.floor(duration % 3600 / 60);
  var seconds = duration % 60;
  var showSeconds = "" + (needSeconds ? seconds + "\u79D2" : '');
  if (days) return days + "\u5929" + hours + "\u5C0F\u65F6" + minutes + "\u5206\u949F" + showSeconds;
  if (hours) return hours + "\u5C0F\u65F6" + minutes + "\u5206\u949F" + showSeconds;
  if (minutes) return minutes + "\u5206\u949F" + showSeconds;
  return "" + showSeconds;
};
/**
 * @description: 最近日期（天）格式化，具体格式化规则如下：
 * 1. 一分钟内：刚刚
 * 2. 一小时内：几分钟前
 * 3. 一天内：今天/上午/下午/凌晨... 时:分
 * 4. 自然天第二天：昨天 时:分
 * 5. 未跨年时：月-日 时:分
 * 6. 跨年：年-月-日 时:分
 * @param {number | string} dateTime 只允许传入时间戳或 YYYY-MM-DD HH:mm:ss 格式
 * @param {FormatDateTimeConfig} config 格式化配置项
 * @param {boolean} [config.needTodayText=false] 当为今日时，是否需要时间段文案，默认展示为【今日 12:30】，需要时展示为【中午 12:30】，时间段规则如下：
 * 凌晨 00:00-06:00 早上 06:00—09:00 上午 09:00-11:00 中午 11:00-13:00 下午 13:00-18:00 晚上 18:00-00:00
 * @param {string} [config.timeFormat='HH:mm'] 时分秒展示格式，默认为 'HH:mm' ,可传入 'HH:mm:ss'、'HH' 等通用时分秒格式规则进行修改
 * @return {string}
 */

var formatDateTime = function formatDateTime(dateTime, config) {
  dayjs.extend(isToday);
  dayjs.extend(isYesterday); // 默认配置

  var defaultConfig = {
    timeFormat: 'HH:mm',
    needTodayText: false
  };

  var _defaultConfig$config = _extends({}, defaultConfig, config),
      timeFormat = _defaultConfig$config.timeFormat,
      needTodayText = _defaultConfig$config.needTodayText;

  if (!dateTime) return ''; // 时间戳换算为毫秒

  if (typeof dateTime === 'number') {
    dateTime = dateTime.toString().length === 10 ? dateTime * 1000 : dateTime;
  }

  var dateFormatText = 'YYYY-MM-DD'; // 今天

  if (dayjs(dateTime).isToday()) {
    var diffValueMinute = dayjs(dateTime).diff(dayjs(), 'm');
    if (diffValueMinute === 0) return '刚刚';
    if (diffValueMinute < 0 && diffValueMinute > -60) return Math.abs(diffValueMinute) + "\u5206\u949F\u524D"; // 处理上下午

    dateFormatText = needTodayText ? dayjs(dateTime).format('a') : '今天';
  } else if (dayjs(dateTime).isYesterday()) {
    // 昨天
    dateFormatText = '昨天';
  } else if (dayjs(dateTime).format('YYYY') === dayjs().format('YYYY')) {
    // 未跨年
    dateFormatText = 'MM-DD';
  }

  return dayjs(dateTime).format(dateFormatText + " " + timeFormat);
};

dayjs.locale('zh-cn');

/**
 * @func
 * @version 0.0.1
 * @param {string} url = location.href
 * @param [options] qs.parse配置项
 * @return {GetUrlQueryType}
 * @desc: 以key:value形式返回url上所有参数，重复参数合并为数组，字符串对象转为对象，数组参数合并为一个数组
 * @example 获取所有参数：getUrlQuery('http://666.com/v1?name=中文&sort=1&arr=0&arr=aaa&list[]=1&list[]=2&obj=%7B%22a%22:4,%22b%22:[1,2],%22c%22:%7B%22f%22:4%7D%7D#锚点');
 * @example 获取指定参数：getUrlQuery(http://666.com/v1?name=土豆').name;
 */
var qs = /*#__PURE__*/require('qs'); // 判断是否为对象字符串


var isJson = function isJson(str) {
  try {
    var obj = JSON.parse(str); // 剔除数字

    if (typeof obj === 'number') {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};

var getUrlQuery = function getUrlQuery(url, option) {
  if (url === void 0) {
    url = window.location.href;
  }

  var result = {};
  var queryStr = url.split('?')[1];
  if (!queryStr) return result;
  queryStr = queryStr.split('#')[0];
  result = qs.parse(queryStr, option); // 处理对象

  Object.keys(result).forEach(function (key) {
    if (isJson(result[key])) {
      result[key] = JSON.parse(result[key]);
    }
  });
  return result;
};

var MoneyUnit;

(function (MoneyUnit) {
  MoneyUnit["YUAN"] = "YUAN";
  MoneyUnit["JIAO"] = "JIAO";
  MoneyUnit["FEN"] = "FEN";
})(MoneyUnit || (MoneyUnit = {}));
/**
 * @description: 千分隔
 * @param {number} val
 * @return {*}
 */


var handleOnDivide = function handleOnDivide(val) {
  var target = Number(val);
  return target.toLocaleString();
};

var divValue = function divValue(unit) {
  var _MoneyUnit$FEN$MoneyU;

  return (_MoneyUnit$FEN$MoneyU = {}, _MoneyUnit$FEN$MoneyU[MoneyUnit.FEN] = 100, _MoneyUnit$FEN$MoneyU[MoneyUnit.JIAO] = 10, _MoneyUnit$FEN$MoneyU[MoneyUnit.YUAN] = 1, _MoneyUnit$FEN$MoneyU)[unit] || 100;
};
/**
 * @description: 数字转金额
 * @param {number | string} value - 所需要处理的数据，传入单位为 分
 * @param {object} options - 配置项
 * @param {number} [options.precision=2] - 小数位数
 * @param {boolean} [options.sign=false] - 是否展示单位 ¥
 * @param {MoneyUnit} [options.unit=MoneyUnit.FEN] - 除数 默认除 100，即传入分 返回 元
 * @param {Decimal.Rounding} [options.rounding=4] - 取整模式，默认四舍五入
 * @see {@link https://lixingwu.gitee.io/decimal.js_cn/cn/index.html#modes | Decimal.Rounding}
 * @return {string}
 */


var formatMoney = function formatMoney(value, options) {
  var defaultConfig = {
    precision: 2,
    sign: false,
    rounding: 4,
    unit: MoneyUnit.FEN
  };

  var _defaultConfig$option = _extends({}, defaultConfig, options),
      precision = _defaultConfig$option.precision,
      sign = _defaultConfig$option.sign,
      rounding = _defaultConfig$option.rounding,
      unit = _defaultConfig$option.unit;

  var target = Decimal.set({
    rounding: rounding
  }).div(new Decimal(value), divValue(unit)).toFixed(precision); // 千分隔处理

  var temp = target.split('.');
  var result = handleOnDivide(temp[0]);
  var symbol = sign ? '¥' : '';
  var suffix = temp[1] ? "." + temp[1] : '';
  /**
   * 还原 Decimal 全局设置
   * https://mikemcl.github.io/decimal.js/#Dset
   */

  Decimal.set({
    defaults: true
  });
  return "" + symbol + result + suffix;
};

/*
 * @Date: 2022-03-07 15:55:24
 * @LastEditors: xiaokun
 * @Description: 数据精度处理
 */

/*
 * @Date: 2022-03-03 13:48:28
 * @LastEditors: xiaokun
 * @LastEditTime: 2022-03-07 10:38:11
 * @Descripttion: 加解密基础函数
 */
var iv = /*#__PURE__*/cryptoJs.enc.Utf8.parse('0123456789ABCDEF');
var crypto = {
  /**
   * @description: 加解密参数
   * @param {string} plain 加解密对象
   * @param {string} key 密钥
   * @return {*}
   */
  encrypt: function encrypt(plain, key) {
    var jsplain = cryptoJs.enc.Utf8.parse("" + plain);
    return cryptoJs.AES.encrypt(jsplain, cryptoJs.MD5(key), {
      iv: iv
    }).ciphertext.toString(cryptoJs.enc.Base64);
  },
  decrypt: function decrypt(encrypted, key) {
    return cryptoJs.AES.decrypt("" + encrypted, cryptoJs.MD5(key), {
      iv: iv
    }).toString(cryptoJs.enc.Utf8).toString();
  }
};

/*
 * @Author: xiaokun
 * @Date: 2022-03-03 17:34:31
 * @LastEditors: xiaokun
 * @Description: 手机号码加密处理
 */
/**
 * @description: 隐藏电话号码
 * @param {string} phone 需要隐藏的电话号码
 * @return {string} 返回隐藏中间四位的电话号码
 */

function hidePhone(phone) {
  if (!phone) return '';
  phone = phone.toString();
  var len = phone.length;
  if (len < 6 || len > 14) return phone;
  var tel = '';
  var mobile = /^[0-9-*\s]+$/;

  if (mobile.test(phone)) {
    tel = phone.substring(0, 3) + '****' + phone.substring(7);
  } else {
    var p = len / 2;
    tel = phone.substring(0, p - 2) + '****' + phone.substring(p + 2);
  }

  return tel;
}
/**
 * @description: 号码加密
 * @param {string} encrypted - 加密对象
 * @param {string | number} key - 密钥
 * @return {string}
 */

function encryptPhone(encrypted, key) {
  var _number = encrypted;
  var decryptNumber = decryptPhone(_number, key);

  if (decryptNumber === _number) {
    try {
      _number = crypto.encrypt(encrypted, key);
    } catch (err) {// console.log(err)
    }
  }

  return _number;
}
/**
 * @description: 号码解密
 * @param {string | number} encrypted - 解密对象
 * @param {string | number} key - 密钥
 * @param {boolean} [isHidePhone=true] - 解密后是否需要隐藏号码中间 4 位。 默认需要
 * @return {string}
 */

function decryptPhone(encrypted, key, isHidePhone) {
  if (isHidePhone === void 0) {
    isHidePhone = true;
  }

  var _number = encrypted;
  var test = /^[0-9-*\s]+$/;

  if (!test.test(encrypted)) {
    try {
      _number = isHidePhone ? hidePhone(crypto.decrypt(encrypted, key)) : crypto.decrypt(encrypted, key);
    } catch (err) {// console.log(err)
    }
  }

  return _number;
}

/**
 * @Author: lidan
 * @Date: 2022-03-10 14:10:05
 * @LastEditors: lidan
 * @Description:
 *  可使用formatFileSize方法获取合适单位的文件大小格式
 *  可使用formatFileSizeByUnit方法获取指定单位的文件大小格式
 */
/**
 * 保留小数点固定位数
 * @param value 原数据
 * @param point 小数点位数
 * @returns 保留固定的小数点位数之后的新数据
 */

function decimalToFixed(value, point) {
  var decimalNumber = new Decimal(value);
  return decimalNumber.toFixed(point);
}
/**
 * 获取指定单位的文件大小格式
 * @param fileSize 文件大小
 * @param unit 指定单位
 * @param point 小数点位数
 * @param mode
 *    可选值 SYSTEM NORMAL
 *    SYSTEM 按系统模式换算（1000） 某些电脑系统磁盘文件大小换算模式为1000
 *    NORMAL 按普通模式换算 （1024）
 * @returns 指定文件单位的文件大小格式数据
 */


function formatFileSizeByUnit(fileSize, unit, point, mode) {
  if (unit === void 0) {
    unit = 'KB';
  }

  if (point === void 0) {
    point = 2;
  }

  if (mode === void 0) {
    mode = 'SYSTEM';
  }

  var upperUnit = unit.toUpperCase();
  var divide = mode === 'SYSTEM' ? 1000 : 1024;
  var units = ['B', 'KB', 'MB', 'GB'];
  var index = units.indexOf(upperUnit);
  return decimalToFixed(fileSize / Math.pow(divide, index), point) + upperUnit;
}
/**
 * 根据文件大小数值自动换算文件大小单位
 * @param fileSize 文件大小
 * @param point 小数点位数
 * @param mode
 *    可选值 SYSTEM NORMAL
 *    SYSTEM 按系统模式换算（1000） 某些电脑系统磁盘文件大小换算模式为1000
 *    NORMAL 按普通模式换算 （1024）
 * @returns 自适应的文件大小单位格式数据
 */

function formatFileSize(fileSize, point, mode) {
  if (point === void 0) {
    point = 2;
  }

  if (mode === void 0) {
    mode = 'SYSTEM';
  }

  var divide = mode === 'SYSTEM' ? 1000 : 1024;

  if (fileSize < divide) {
    return decimalToFixed(fileSize, point) + 'B';
  } else if (fileSize < Math.pow(divide, 2)) {
    var temp = fileSize / divide;
    return decimalToFixed(temp, point) + 'KB';
  } else if (fileSize < Math.pow(divide, 3)) {
    var _temp = fileSize / Math.pow(divide, 2);

    return decimalToFixed(_temp, point) + 'MB';
  } else {
    var _temp2 = fileSize / Math.pow(divide, 3);

    return decimalToFixed(_temp2, point) + 'GB';
  }
}

/*
 * @Date: 2022-03-14 14:12:00
 * @LastEditors: xiaokun
 * @Description: storage 操作方法
 */
/** storage 通用部分 --- strat */

var setItem = function setItem(key, value, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }

  var setValue = '';

  try {
    setValue = JSON.stringify(value);
  } catch (_unused) {}

  storage.setItem(key, setValue);
};

var getItem = function getItem(key, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }

  var value = storage.getItem(key);
  if (!value) return undefined;

  try {
    return JSON.parse(value);
  } catch (_unused2) {}

  return undefined;
};

var removeItem = function removeItem(key, storage) {
  if (storage === void 0) {
    storage = window.sessionStorage;
  }

  storage.removeItem(key);
};
/** storage 通用部分 --- end */

/** sessionStorage */


var setSessionItem = function setSessionItem(key, value) {
  setItem(key, value);
};

var getSessionItem = function getSessionItem(key) {
  return getItem(key);
};

var removeSessionItem = function removeSessionItem(key) {
  removeItem(key);
};
/** localStorage */


var setLocalItem = function setLocalItem(key, value) {
  setItem(key, value, window.localStorage);
};

var getLocalItem = function getLocalItem(key) {
  return getItem(key, window.localStorage);
};

var removeLoaclItem = function removeLoaclItem(key) {
  removeItem(key, window.localStorage);
};
/** cookie */


var setCookieItem = function setCookieItem() {
  var setValue = '';

  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  try {
    setValue = JSON.stringify(params[1]);
  } catch (_unused3) {}

  params[1] = setValue;
  return Cookies.set.apply(Cookies, params);
};

var getCookieItem = function getCookieItem(key) {
  var value = Cookies.get(key);
  if (!value) return undefined;

  try {
    return JSON.parse(value);
  } catch (_unused4) {}

  return undefined;
};

var removeCookieItem = function removeCookieItem() {
  return Cookies.remove.apply(Cookies, arguments);
};

var storage = {
  setSessionItem: setSessionItem,
  getSessionItem: getSessionItem,
  removeSessionItem: removeSessionItem,
  setLocalItem: setLocalItem,
  getLocalItem: getLocalItem,
  removeLoaclItem: removeLoaclItem,
  setCookieItem: setCookieItem,
  getCookieItem: getCookieItem,
  removeCookieItem: removeCookieItem
};

/*
 * @Author: xiaokun
 * @Date: 2022-02-17 11:18:03
 * @LastEditors: xiaokun
 * @Description: 用户数据读写函数
 */

var removeUser = function removeUser(key) {
  if (key === void 0) {
    key = 'user';
  }

  storage.removeLoaclItem(key);
};
/**
 * @description: 存入用户信息
 * @param {object} value
 * @param {string} key - 默认 key 为 user, 可传入修改
 */


var setUser = function setUser(value, key) {
  if (key === void 0) {
    key = 'user';
  }

  storage.setLocalItem(key, value);
};
/**
 * @description: 获取用户信息
 * @param {string} key - 默认 key 为 user, 可传入修改为 qw-user
 */

var getUser = function getUser(key) {
  if (key === void 0) {
    key = 'user';
  }

  var user = storage.getLocalItem(key);
  if (!user) return undefined;

  try {
    return user;
  } catch (_unused) {}

  return undefined;
};
/**
 * @description: 获取用户 sid
 * @param {string} key - 默认 key 为 user, 可传入修改为 qw-user
 */

var getSessionId = function getSessionId(key) {
  if (key === void 0) {
    key = 'user';
  }

  var user = getUser(key);
  if (!user || !user.sid) return undefined;

  try {
    return user.sid;
  } catch (_unused2) {}

  return undefined;
};
var userStorage = {
  setUser: setUser,
  getUser: getUser,
  removeUser: removeUser,
  getSessionId: getSessionId
};

/*
 * @Author: zhaoyj
 * @Date: 2022-03-22 16:29:53
 * @LastEditTime: 2022-03-22 18:53:01
 * @LastEditors: zhaoyj
 * @Description:
 */

/**
 *
 * @param {number} duration 秒
 * @param {string} format
 * d/dd 天
 * h/hh 小时
 * m/mm 分钟
 * s/ss 秒
 * @returns {string}
 */
var durationFormat = function durationFormat(duration, format) {
  if (format === void 0) {
    format = 'hh:mm:ss';
  }

  if (!duration || typeof duration !== 'number') return '';
  var dayReg = /([Dd])\1?/g;
  var hourReg = /([Hh])\1?/g;
  var minuteReg = /([Mm])\1?/g;
  var secondReg = /([Ss])\1?/g;
  var days = '';
  var hours = '';
  var minutes = '';
  var seconds = '';
  var ONE_MINUTE = 60;
  var ONE_HOUR = ONE_MINUTE * 60;
  var ONE_DAY = ONE_HOUR * 24;
  return format.replace(dayReg, function ($0) {
    days = "" + ~~(duration / ONE_DAY);
    return days.padStart($0.length, '0');
  }).replace(hourReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    hours = "" + ~~(filterDays / ONE_HOUR);
    return hours.padStart($0.length, '0');
  }).replace(minuteReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    var filterHours = hours ? filterDays % ONE_HOUR : filterDays;
    minutes = "" + ~~(filterHours / ONE_MINUTE);
    return minutes.padStart($0.length, '0');
  }).replace(secondReg, function ($0) {
    var filterDays = days ? duration % ONE_DAY : duration;
    var filterHours = hours ? filterDays % ONE_HOUR : filterDays;
    seconds = minutes ? "" + filterHours % ONE_MINUTE : "" + filterHours;
    return seconds.padStart($0.length, '0');
  });
};

/*
 * @Date: 2022-03-29 16:21:49
 * @LastEditors: xiaokun
 * @Description: 文件下载
 */

/**
 * @description: 文件下载，目前不支持跨域文件重命名
 * @param {string} url 文件地址
 * @param {string} title 需重命名的名称
 * @return {*}
 */
var download = function download(url, title) {
  var a = document.createElement('a');
  var event = new MouseEvent('click'); // 下载图名字

  a.download = title || ''; // url

  a.href = url; // 合成函数，执行下载

  a.dispatchEvent(event);
  a = null;
};

function getUser$1(userKey) {
  if (userKey) {
    return userStorage.getUser(userKey);
  }

  return userStorage.getUser('user') || userStorage.getUser('qw-user');
}

function matchCorpId(domain) {
  var matchGroup = domain.match(/([A-Za-z0-9-]+)-qw-scrm/);

  if (!matchGroup) {
    return undefined;
  }

  var corpId = matchGroup[1];
  var index = matchGroup['index'];
  return {
    corpId: corpId,
    index: index,
    domain: domain
  };
}
/**判断是否是私有云 */


function isPrivate() {
  var _window$envConfig;

  return ((_window$envConfig = window.envConfig) == null ? void 0 : _window$envConfig.VUE_APP_CONFIG_CORPID) !== '0';
}

function getDomainUrl(userKey) {
  var user = getUser$1(userKey);

  if (user != null && user.domain) {
    return user.domain;
  }

  return location.origin;
}

function makeFullUrl(url) {
  if (url.includes('//')) {
    return url;
  }

  return "https://" + url;
}

function removeCorpId(url) {
  var newUrl = makeFullUrl(url);
  var match = matchCorpId(newUrl);
  if (!match) return newUrl;
  return newUrl.replace(match.corpId + '-', '');
}

function getPrivateCloudDomain(domainUrl, userOrigin) {
  return removeCorpId(userOrigin || domainUrl);
}

function appendCorpId(url, corpId) {
  if (url.includes('//')) {
    var _url$split = url.split('//'),
        prefix = _url$split[0],
        origin = _url$split[1];

    return prefix + "//" + corpId + "-" + origin;
  }

  return "https://" + corpId + "-" + url;
}

function getDomain(domainUrl, userOrigin) {
  var match = matchCorpId(domainUrl);

  if (!match) {
    console.error('未获取到domain前缀，组装url失败');
    return userOrigin || domainUrl;
  }

  var corpId = match.corpId;

  if (userOrigin) {
    return appendCorpId(userOrigin, corpId);
  }

  return makeFullUrl(domainUrl);
}
/**
 * 获取domain路由前缀
 * - 私有云环境下，调用该函数返回的接口始终为空
 */


function getDomainAffix(userStorageKey) {
  if (isPrivate()) {
    return '';
  }

  var domainUrl = getDomainUrl(userStorageKey);
  var match = matchCorpId(domainUrl);

  if (!match) {
    console.error('获取domain前缀失败');
    return '';
  }

  return match.corpId;
}
/**
 * 获取当前环境的完整路由，支持外部传入自定义的url
 * @param option 选项
 * @returns 最终的url
 */

function getDecorateOrigin(option) {
  if (option === void 0) {
    option = {};
  }

  var _option = option,
      origin = _option.origin,
      userKey = _option.userKey;
  var domainUrl = getDomainUrl(userKey);

  if (isPrivate()) {
    return getPrivateCloudDomain(domainUrl, origin);
  }

  return getDomain(domainUrl, origin);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

function loadComponent(scope, module) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
    var container, factory, Module;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_init_sharing__('default');

          case 2:
            container = window[scope]; // or get the container somewhere else
            // Initialize the container, it may provide shared modules

            _context.next = 5;
            return container.init(__webpack_share_scopes__["default"]);

          case 5:
            _context.next = 7;
            return container.get(module);

          case 7:
            factory = _context.sent;
            Module = factory();
            return _context.abrupt("return", Module);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

var urlCache = /*#__PURE__*/new Set();

function loadDynamicScript(url) {
  return new Promise(function (resolve) {
    if (!url) {
      resolve(false);
      return;
    }

    if (urlCache.has(url)) {
      resolve(true);
      return;
    }

    var element = document.createElement('script');
    element.src = url;
    element.type = 'text/javascript';
    element.async = true;

    element.onload = function () {
      urlCache.add(url);
      resolve(true);
    };

    element.onerror = function () {
      resolve(false);
    };

    document.head.appendChild(element);
  });
}

function loadFederatedComponent(_ref2, module) {
  var remoteUrl = _ref2.remoteUrl,
      scope = _ref2.scope;
  return loadDynamicScript(remoteUrl).then(function (succss) {
    if (succss) {
      return loadComponent(scope, module)();
    } // 返回占位组件


    return Promise.resolve({});
  });
}
function getHost(config) {
  var port = config.port,
      _config$publicPath = config.publicPath,
      publicPath = _config$publicPath === void 0 ? '' : _config$publicPath,
      _config$ip = config.ip,
      ip = _config$ip === void 0 ? 'localhost' : _config$ip,
      _config$entryName = config.entryName,
      entryName = _config$entryName === void 0 ? 'remoteEntry' : _config$entryName;
  var host = process.env.NODE_ENV === 'development' ? "//" + ip + ":" + port : window.location.origin;
  var splits = [host];

  if (publicPath) {
    splits.push(publicPath);
  }

  splits.push(entryName + ".js");
  return splits.join('/');
}

function isLoadScript(url) {
  var scripts = document.scripts;

  for (var i = 0; i < scripts.length; i++) {
    var _scripts$i;

    if ((_scripts$i = scripts[i]) != null && _scripts$i.src.includes(url)) {
      return true;
    }
  }

  return false;
}

/**
 * @description: 加载 head 标签
 * @param {string} url 加载地址
 * @param {'js' | 'css'} type 加载类型
 */

var addScript = function addScript(url, type) {
  if (isLoadScript(url)) {
    return;
  }

  if (type === 'css') {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  } else {
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);
    document.head.appendChild(script);
  }
};
var createLink = function createLink(linkUrl) {
  var scriptUrl = linkUrl.script,
      cssUrl = linkUrl.css;
  addScript(scriptUrl, 'js');
  addScript(cssUrl, 'css');
};

export { Decimal, MoneyUnit, addScript, createLink, crypto, dayjs, decryptPhone, download, durationFormat, encryptPhone, formatDateTime, formatFileSize, formatFileSizeByUnit, formatMoney, formatSeconds, getDecorateOrigin, getDomainAffix, getHost, getUrlQuery, hidePhone, loadFederatedComponent, storage, userStorage };
//# sourceMappingURL=iutils.esm.js.map
